var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNamibia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0e2a68",
    d: "M0 0h26c1 0 1.95.38 2.68 1.05L1.32 22.95A4 4 0 0 1 0 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#44994d",
    d: "M30 24H2.8c-1.03 0-2.04-.4-2.8-1.1L28.62 0A4.2 4.2 0 0 1 30 3.08z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 0h-5.6L0 19.54V24h5.6L30 4.48z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M26 0 0 20.75V24h4L30 3.25V0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ce46",
    d: "M6.34 5.36a1.73 1.73 0 1 0 0 3.45 1.73 1.73 0 0 0 0-3.45m-.53-.28q.54-.15 1.07 0l-.54-1.45z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ce46",
    d: "M8.35 7.62 9.8 7.1l-1.45-.54.99-1.2-1.53.27.26-1.53-1.19 1a2.08 2.08 0 0 1-.54 4.07 2.08 2.08 0 0 1-.53-4.08L4.6 4.1l.27 1.53-1.53-.26.99 1.19-1.46.54 1.46.53-1 1.2 1.54-.27-.27 1.53 1.2-.99.53 1.45.54-1.45 1.2 1-.27-1.54 1.53.26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamibia);
export default __webpack_public_path__ + "static/media/namibia.2c8a95d62246392c77206303152478d5.svg";
export { ForwardRef as ReactComponent };